//Default imports
import React from 'react';

// Importing the styled components
import {
  Container,
  Box,
  Links,
  LinksContainer,
  LogoArea,
  NavBarContainer,
  Slashes,
  Heart,
} from './SubNavbarStyles';

//Logo

//Icons

//Dropdown
import Dropdown from '../../../Components/Utils/Dropdown';

export default function SubNavbar() {
  // About Functionality
  const dropdownOptionsAbout = ['Description', 'Attributions', 'Sponsors']; // Option for About Dropdown
  const aboutRoutes = ['/description', '/attributions', '/sponsors'];

  // Initiatives Functionality
  const dropdownOptionsInitiatives = [
    'Engineering',
    'Results',
    'Contributions'
  ]; // Option for Initiatives Dropdown
  const initiativesRoutes = [
    '/engineering',
    '/results',
    '/contribution'
  ];

  // Projects Functionality
  const dropdownOptionsProjects = [
    'Kinetic Model',
    'Normalization Model',
    'Safety'
  ]; // Option for Projects Dropdown
  const projectsRoutes = [
    '/kineticmodel',
    '/normalizationmodel',
    '/safety'
  ];

  // News Functionality
  const dropdownOptionsNews = [
    'Overview',
    'Treatment Report',
    'Entrepreneurship',
    'Integrated Human Practices',
    "Women's Report",
  ]; // Option for News Dropdown
  const newsRoutes = [
    '/overview',
    '/treatment-report',
    '/entrepreneurship',
    '/human-practices',
    '/womensreport',
  ];

  return (
    <Container>
      <Box>
        <NavBarContainer>
          <LogoArea>
            <Links route='/'><a href="/mcmaster-canada"><Heart src='https://static.igem.wiki/teams/4751/wiki/mgemlogo.png' /></a></Links>
          </LogoArea>
          <LinksContainer>
            <Links>
              <Dropdown
                options={dropdownOptionsAbout}
                routes={aboutRoutes}
                navItemName="ABOUT"
              />
            </Links>
            <Slashes>/</Slashes>
            <Links>
              {' '}
              <Dropdown
                options={dropdownOptionsInitiatives}
                routes={initiativesRoutes}
                navItemName="WET LAB"
              />
            </Links>
            <Slashes>/</Slashes>
            <Links>
              {' '}
              <Dropdown
                options={dropdownOptionsProjects}
                routes={projectsRoutes}
                navItemName="DRY LAB"
              />
            </Links>
            <Slashes>/</Slashes>
            <Links>
              {' '}
              <Dropdown
                options={dropdownOptionsNews}
                routes={newsRoutes}
                navItemName="OVERVIEW OF HUMAN PRACTICES"
              />
            </Links>
          </LinksContainer>
        </NavBarContainer>
      </Box>
    </Container>
  );
}
